// extracted by mini-css-extract-plugin
export default {"spinner":"Be7GcWbnrWQHPKwYB0Vg","animation-spin":"ItHB2jazs1wB9dWSpOHg"};